import React from "react";
import { Link } from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import mainBg from "../../assets/img/bg-recruit.jpg";
import challengerIc from "../../assets/img/icons/award.svg";
import creatorIc from "../../assets/img/icons/idea.svg";
import coworkerIc from "../../assets/img/icons/team.svg";


function RecruitmentGuide() {
	
	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
	const isAdmin = argInfo?.role === 'admin';
	
    return (<>

	<main className="page-wrapper">
			{isAdmin ? <AdminHeader /> : <Header />}
        {/* <!-- 메인 미이지 + 슬로건 --> */}
				<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
						<div className="textBox">
							<h2>인재채용</h2>
							<p>위피아는 고객의 행복과 풍요로움을 먼저 생각하는 스마트 IT 서비스 전문 기업입니다.</p>
						</div>
						<SubMenu />
				</section>
			
				<section className="container-auto sec-my">
					<h3 className="sub-title">채용안내</h3>
					<p className="sub-text">위피아는 고객의 경쟁력과 가치창조 실현을 위하여 IT Consulting 및 LBS, Mobile, 물류, 환경모니터링 분야의 특화된 솔루션 공급과 창의적 지식과 경쟁력으로 고객에게 최적화된 스마트 IT 서비스 기업이 되도록 최선의 노력을 다 하겠습니다.</p>
					<p className="recruit-mail">
						<span className="title">상시접수 이메일</span>
						<span className="mail">info@wipia.co.kr</span>
					</p>
				</section>

				<section className="container-auto sec-my">
					<h3 className="sub-title">위피아 인재상</h3>
					<p className="sub-text">자신의 분야에서 끊임없는 성장과 함께 창의적인 시선으로 변화를 주도하며, 팀워크를 바탕으로 공동의 성과를 끌어낼 수 있는 인재를 찾고 있습니다.</p>


					<ul className="recruit-list">
						<li>
							<div className="recruit-inner">
								<div className="textBox">
									<p className="title">Challenger</p>
									<p className="text">열정과 도전정신을 가지고
									끊임없는 성장을 추구하는 사람</p>
								</div>
							</div>
						</li>
						<li>
							<div className="recruit-inner">
								<div className="textBox">
									<p className="title">Creator</p>
									<p className="text">창조적이며 기존의 상식과
									틀을 과감히 깨는 혁신적인 사람</p>
								</div>
							</div>
						</li>
						<li>
							<div className="recruit-inner">
								<div className="textBox">
									<p className="title">Coworker</p>
									<p className="text">타인을 존중하고 동료간에 협조할 줄 아는
									역할과 책임을 다하는 사람</p>
								</div>
							</div>
						</li>
					</ul>

				</section>

				<section className="container-auto sec-my">
					<h3 className="sub-title">기타 유의사항</h3>
					<p className="sub-text">서류전형, 면접 합격자는 E-mail, 전화 등으로 개별 통지</p>

					<ul className="recruit-notice">
						<li>
							<p className="num">01</p>
							<p className="text">입사지원서 기재 사항 중 허위사실이 판명될 경우
							합격 및 입사가 취소됨</p>
						</li>
						<li>
							<p className="num">02</p>
							<p className="text">접수된 서류는 일체 반환하지 않음</p>
						</li>
						<li>
							<p className="num">03</p>
							<p className="text">해외 여행에 결격 사유가 없는 자</p>
						</li>
					</ul>
				</section>
		</main>
	<Footer />
        </>
    )
}

export default RecruitmentGuide;